import { SidebarTrigger } from '../appSideBar/sidebar';

import { BaseTopNavigation } from './BaseTopNavigation';
import { TopNavigationCareLogo } from './TopNavigationCareLogo';
import { TopNavigationInquiryButton } from './TopNavigationInquiryButton';
import { BaseTopNavigationProps } from './type/BaseTopNavigationType';

interface LogoTopNavigationProps extends Pick<BaseTopNavigationProps, 'bg' | 'bgColor'> {
  logoColor?: string;
  buttonTextColor?: string;
  isMenuButton?: boolean;
  onMenuButtonClick?: () => void;
  topLogoPath?: string;
}

export function LogoTopNavigation({ bg, bgColor, logoColor, isMenuButton, buttonTextColor, onMenuButtonClick, topLogoPath, ...props }: LogoTopNavigationProps) {
  return (
    <BaseTopNavigation
      leftAction={<TopNavigationCareLogo color={logoColor} path={topLogoPath} />}
      rightAction={
        <div className="flex shrink-0 items-center gap-tiny-small">
          <TopNavigationInquiryButton textColor={buttonTextColor} />
          {isMenuButton && <SidebarTrigger />}
        </div>
      }
      bg={bg}
      bgColor={bgColor}
      {...props}
    />
  );
}
